import { render } from "./OrdersSccess.vue?vue&type=template&id=606ea156&scoped=true"
import script from "./OrdersSccess.vue?vue&type=script&lang=js"
export * from "./OrdersSccess.vue?vue&type=script&lang=js"

import "./OrdersSccess.vue?vue&type=style&index=0&id=606ea156&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-606ea156"]])

export default __exports__